export default class LinkObject {

    constructor(object, href) {
        this.href = href;

        this._object = object;

        this._handleHover = this._handleHover.bind(this);
        this._handleMouseDown = this._handleMouseDown.bind(this);
    }

    observe(observer) {
        this._observer = observer;
        observer.addObject(this._object);
        observer.addListener(this._handleHover);
    }

    _handleHover(closest) {
        if (closest === this._object) {
            this._observer.root.addEventListener("mousedown", this._handleMouseDown);
            this._observer.root.classList.add("cursor-pointer");
        } else {
            this._observer.root.removeEventListener("mousedown", this._handleMouseDown);

            if (closest === null) {
                this._observer.root.classList.remove("cursor-pointer");
            }
        }
    }

    _handleMouseDown() {
        const mouseUpHandler = () => {
            window.location.href = this.href;
        };
        this._observer.root.addEventListener("mouseup", mouseUpHandler, { once: true });
        setTimeout(() => this._observer.root.removeEventListener("mouseup", mouseUpHandler), 200);
    }

}
